import { NavLink } from "react-router-dom";

import { Link, TextAvatar } from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { createOrganizationLink } from "@utils/navigation";

import "./organization.box.scss";

export const OrganizationBox = ({
  organization,
  breadcrumbLabel,
  onRemove,
  enableRemove,
}) => {
  const { name, code } = organization ?? {};
  const pathConfig = createOrganizationLink({
    code,
    search: { from: breadcrumbLabel },
  });

  return (
    <div className="organization-box">
      <TextAvatar text={[name]} />
      <Link routerComponent={NavLink} to={pathConfig}>
        {name}
      </Link>
      {enableRemove && (
        <Button
          borderless
          icon={["fa-regular", "xmark"]}
          onClick={() => onRemove && onRemove(organization)}
        ></Button>
      )}
    </div>
  );
};

export const ORGS_DISPLAY_LIMIT = 3;

export const RemainderBox = ({ organizations, onClick }) => {
  if (organizations.length <= ORGS_DISPLAY_LIMIT) {
    return null;
  }

  return (
    <div className="organization-box">
      <Link className="organization-box-link" onClick={onClick}>
        + {organizations.length - ORGS_DISPLAY_LIMIT}
      </Link>
    </div>
  );
};
